import { useTexts } from "Components/TextContext";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { InsuranceProduct } from "Store/interfaces/products/checkout";

export const getAdditonalDeleteProductText = (
  products: InsuranceProduct[],
): string | undefined => {
  const { getText } = useTexts();
  if (products.length === 2) {
    const hasBothChildAndChildHealth = [
      INSURANCE_NAME_VALUE.NEW_CHILD,
      INSURANCE_NAME_VALUE.CHILD_HEALTH,
    ].map((name) => products.some((product) => product.name === name));

    if (hasBothChildAndChildHealth) {
      return ` ${getText("offer.removeproductdrawer.childhealth")}`;
    }
  }
};
